import React from 'react';
import ReactDOM from 'react-dom';
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { persistStore } from 'redux-persist'
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { composeWithDevTools } from 'redux-devtools-extension';
import Routes from './routes';
import rootReducer from "./redux/reducers";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./assets/css/custom.css";



export const store = createStore(rootReducer,  composeWithDevTools(applyMiddleware(thunk)));;
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <PersistGate persistor={persistor}>
        <Routes />
      </PersistGate>
    </React.StrictMode>

  </Provider>,
  document.getElementById('root')
);

